'use client'

import React, { useState } from 'react'

import { useQuery } from '@apollo/client'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import {
  AccessSection,
  EmajinMembershipsSection,
  GetAppSection,
  GrowSection,
  HomeHeroSection,
  HowItWorksSection,
  LatestNewsSection,
  LearnSection,
  OurPartnersSection,
  OurPlatinumMembersSection,
  TestimonialsSection,
  WelcomeSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import { HomePageDocument } from 'GraphQL/DatoCMS/TypedDocuments'

function HomePage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  const { data, loading } = useQuery(HomePageDocument, {
    context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
  })

  if (loading) return <Loader fullScreen size={32} />

  return (
    <Column alignCenter fullWidth>
      <HomeHeroSection onAction={() => setJoinUsModalModalOpened(true)} />

      <WelcomeSection />

      <AccessSection />

      <LearnSection onAction={() => setJoinUsModalModalOpened(true)} />

      <GrowSection onAction={() => setJoinUsModalModalOpened(true)} />

      <EmajinMembershipsSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <HowItWorksSection onAction={() => setJoinUsModalModalOpened(true)} />

      <GetAppSection />

      <TestimonialsSection
        data={data?.homePage?.testimonial}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <OurPartnersSection data={data} pb={54} />
      <OurPlatinumMembersSection data={data} pb={[54, 54, 80]} />

      <LatestNewsSection />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default HomePage
